module.exports = __webpack_public_path__ + "static/media/Gilgamesh.f1f2f3e3.jpg";